export const reviews: Array<[string, string, string, string]> = [
  [
    'AP',
    'Andrea P.',
    'Docente de Topografía — Lima, Perú',
    'Mis alumnos por fin entienden la diferencia entre planimetría y altimetría. Antes yo misma perdía tiempo buscando cómo explicar las mediciones correctamente. Ahora entro al aula con todo listo.',
  ],
  [
    'CM',
    'Carlos M.',
    'Profesor de Topografía — Buenos Aires, Argentina',
    'Nunca más llegué a una clase sin saber cómo explicar una poligonal cerrada o cómo se calcula una nivelación. El material hace el trabajo pesado por mí.',
  ],
  [
    'SL',
    'Sofía L.',
    'Docente de Topografía — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Las prácticas de campo están organizadas paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'VT',
    'Valeria T.',
    'Docente de Topografía | Lima, Perú',
    'El material sobre planimetría y altimetría le cambió la cara a mis alumnos. Por fin entienden las diferencias sin confundirse. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'CR',
    'Carlos R.',
    'Profesor de Topografía | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto.',
  ],
  [
    'DG',
    'Daniel G.',
    'Docente de Topografía | Caracas, Venezuela',
    'Los 100 problemas resueltos transformaron a los alumnos que no entendían cálculos. Ahora ven paso a paso cómo se resuelve y lo aplican solos. Eso no lo encontré en ningún otro material.',
  ],
  [
    'AM',
    'Ana M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'La guía visual de instrumentos me devolvió el tiempo de clase. Antes perdía veinte minutos explicando cómo se usa un teodolito. Ahora proyecto la guía y mis alumnos entienden al instante.',
  ],
  [
    'SR',
    'Sebastián R.',
    'Profesor de Topografía | Quito, Ecuador',
    'Los 30 proyectos integradores fueron una revelación. Mis alumnos finalmente entienden para qué es todo esto. Hacen proyectos en sus propios territorios. Eso cambió completamente su relación con la topografía.',
  ],
];
